"use strict";

var _jsxRuntime = require("react/jsx-runtime");
module.exports = ({
  title,
  titleId,
  size,
  color,
  ...props
}) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("svg", {
  ...props,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  height: size,
  width: size,
  fill: color,
  role: title ? 'img' : undefined,
  "aria-hidden": !title,
  "aria-labelledby": titleId,
  children: [title ? /*#__PURE__*/(0, _jsxRuntime.jsx)("title", {
    id: titleId,
    children: title
  }) : null, /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    fillRule: "evenodd",
    d: "M8.786 6.91 7.202 9.847a.473.473 0 0 0-.046.336 9.468 9.468 0 0 0 6.967 6.972.42.42 0 0 0 .343-.035l2.939-1.585a1.324 1.324 0 0 1 1.562.225l2.221 2.222c.249.255.386.587.386.935 0 .353-.136.685-.385.933l-1.326 1.326a1.333 1.333 0 0 1-1.016.384 17.94 17.94 0 0 1-16.41-16.4c-.032-.371.112-.75.386-1.018l1.325-1.326c.248-.248.58-.384.935-.384.347 0 .679.137.933.384l2.538 2.53c.383.383.493.943.294 1.432l-.062.132Zm-5.3-4.757c.808-.806 2.197-.845 3.06-.115l.125.115 2.537 2.538c.667.666.845 1.654.47 2.507l-.078.158-1.492 2.78a8.582 8.582 0 0 0 5.793 5.996l.284.081 2.772-1.492a2.276 2.276 0 0 1 2.538.275l.128.117 2.221 2.222c.424.415.656.977.656 1.582a2.24 2.24 0 0 1-.526 1.447l-.136.148-1.318 1.319c-.42.426-.999.67-1.59.67-.055 0-.11 0-.165-.008A18.871 18.871 0 0 1 1.505 5.236a2.231 2.231 0 0 1 .54-1.63l.123-.133 1.319-1.32Zm10.725-.651c4.57 0 8.289 3.718 8.289 8.289a.554.554 0 0 1-1.105 0c0-3.961-3.223-7.184-7.184-7.184a.553.553 0 1 1 0-1.105Zm0 4.42a3.872 3.872 0 0 1 3.868 3.869.554.554 0 0 1-1.105 0 2.767 2.767 0 0 0-2.763-2.763.553.553 0 1 1 0-1.105Z",
    clipRule: "evenodd"
  })]
});